<template>
  <div>
    <nav class="bg-zt-normal rounded-zt">
      <ul class="text-base font-normal">
        <li class="pl-4 py-4 cursor-pointer border-b border-zt-light rounded-t-zt relative h-[65px] flex items-center
                   hover:bg-zt-light/35"
            :class="{ 'tab-selected': betStore.selectedTab === 'TabBets' }"
            @click="changeTab('TabBets')">
          <span class="relative mr-3">
            <img :src="'/wp-content/themes/zawodtyper/assets/images/bets_tabs/TabBets.svg'"
                 class="inline pointer-events-none"
                 alt="" width="30" height="30">
          </span>
          Typy
	        <span ref="redDot" class="hidden left-[38px] w-[8px] top-[14px] h-[8px] absolute rounded-[24px] bg-zt-red
	                                  flex justify-center">
		        <span ref="pinging" class="animate-ping-once w-[8px] h-[8px] rounded-[24px] bg-zt-red"></span>
	        </span>
        </li>
        <li class="pl-4 py-4 cursor-pointer border-b border-zt-light relative h-[65px] flex items-center hover:bg-zt-light/35"
            :class="{ 'tab-selected': betStore.selectedTab === 'TabRankings' }"
            @click="changeTab('TabRankings')">
          <img :src="'/wp-content/themes/zawodtyper/assets/images/bets_tabs/TabRankings.svg'"
               class="inline mr-3 pointer-events-none"
               alt="" width="30" height="30">
          Ranking Typerów
        </li>
        <li class="pl-4 py-4 cursor-pointer border-b border-zt-light relative h-[65px] flex items-center hover:bg-zt-light/35"
            :class="{ 'tab-selected': betStore.selectedTab === 'TabPrizes' }"
            @click="changeTab('TabPrizes')">
          <img :src="'/wp-content/themes/zawodtyper/assets/images/bets_tabs/TabPrizes.svg'"
               class="inline mr-3 pointer-events-none"
               alt="" width="30" height="30">
          Nagrody
        </li>
        <li class="pl-4 py-4 cursor-pointer border-b border-zt-light relative h-[65px] flex items-center hover:bg-zt-light/35"
            :class="{ 'tab-selected': betStore.selectedTab === 'TabRules' }"
            @click="changeTab('TabRules')">
          <img :src="'/wp-content/themes/zawodtyper/assets/images/bets_tabs/TabRules.svg'"
               class="inline mr-3 pointer-events-none"
               alt="" width="30" height="30">
          Zasady
        </li>
        <li class="pl-4 py-4 cursor-pointer border-b border-zt-light relative h-[65px] flex items-center hover:bg-zt-light/35"
            :class="{ 'tab-selected': betStore.selectedTab === 'TabSettings' }"
            @click="changeTab('TabSettings')">
          <img :src="'/wp-content/themes/zawodtyper/assets/images/bets_tabs/TabSettings.svg'"
               class="inline mr-3 pointer-events-none"
               alt="" width="30" height="30">
          Ustawienia
        </li>
        <li class="pl-4 py-4 cursor-pointer rounded-b-zt relative h-[65px] flex items-center hover:bg-zt-light/35"
            :class="{ 'tab-selected': betStore.selectedTab === 'TabCoupons' }"
            @click="changeTab('TabCoupons')">
          <img :src="'/wp-content/themes/zawodtyper/assets/images/bets_tabs/TabCoupons.svg'"
               class="inline mr-3 pointer-events-none z-40"
               alt="" width="30" height="30">
          Twój kupon
          <div v-if="couponStore.addedBets.length > 0" class="absolute text-center top-2">
            <div class="absolute rounded-full bg-zt-red animate-scale-out w-[18px] h-[18px] z-40 flex items-center
                        justify-center"
                 :class="{ '!animate-scale-out-2': betsInCoupon > 1 }">
              {{ betsInCoupon }}
            </div>
          </div>
        </li>
      </ul>
    </nav>
    <div v-if="userStore.isElevatedUser" class="bg-zt-normal flex flex-col items-center gap-4 rounded-zt p-2 shadow-zt my-4">
      <div v-if="userStore.userCanSettle" class="form-check form-switch flex justify-between w-full">
        <span>Rozliczanie Typów</span>
        <input class="form-check-input appearance-none w-9 rounded-full h-5 bg-no-repeat border border-gray-400
                      cursor-pointer shadow-sm focus:outline-none checked:bg-green-600 checked:border-green-600"
               type="checkbox" role="switch" aria-label="Rozliczanie typów" v-model="settingsStore.settlement">
      </div>
      <div class="form-check form-switch flex justify-between w-full">
        <span>Tylko reklamy</span>
        <input class="form-check-input appearance-none w-9 rounded-full h-5 bg-no-repeat border border-gray-400
                      cursor-pointer shadow-sm focus:outline-none checked:bg-green-600 checked:border-green-600"
               type="checkbox" role="switch" aria-label="Tylko reklamy" v-model="settingsStore.adsFilter">
      </div>
    </div>

    <div v-if="userStore.userCanSettle"
         @click="window.open('/wp-admin/edit-comments.php?comment_status=moderated', '_blank')"
         class="bg-zt-red/20 border border-zt-red rounded-zt flex justify-between items-center px-1 h-[30px]
                cursor-pointer"
         :class="{ '!border-zt-more !bg-zt-more/20': WP.commentsToApproveCount === 0 }">
      <span class="text-xs">Komentarze</span>
      <div class="bg-zt-red rounded-zt w-[18px] h-[18px] font-semibold flex justify-center items-center shrink-0"
           :class="{ '!bg-zt-more': WP.commentsToApproveCount === 0 }">
        {{ Math.min(WP.commentsToApproveCount, 9) }}
      </div>
    </div>
    <div v-if="userStore.userCanSettle"
         @click="window.open('/panel-admina/#zgloszenia', '_blank')"
         class="bg-zt-red/20 border border-zt-red rounded-zt flex justify-between items-center px-1 h-[30px]
                cursor-pointer mt-2"
         :class="{ '!border-zt-more !bg-zt-more/20': WP.reportCount === 0 }">
      <span class="text-xs">Zgłoszenia</span>
      <div class="bg-zt-red rounded-zt w-[18px] h-[18px] font-semibold flex justify-center items-center shrink-0"
           :class="{ '!bg-zt-more': WP.reportCount === 0 }">
        {{ Math.min(WP.reportCount, 9) }}
      </div>
    </div>
  </div>
</template>

<script>
import { useBetStore } from '../stores/BetStore.js';
import { useUserStore } from '../stores/UserStore.js';
import { useSettingsStore } from '../stores/SettingsStore.js';
import { useCouponStore } from "../stores/CouponStore.js";

export default {
  name: 'LeftSidebar',
  inject: ['WP'],
  setup() {
    const betStore = useBetStore();
    const userStore = useUserStore();
    const settingsStore = useSettingsStore();
    const couponStore = useCouponStore();
    return { betStore, userStore, settingsStore, couponStore };
  },
  computed: {
    betsInCoupon() {
      return this.couponStore.addedBets.length;
    },
    newBetsCount() {
      return this.betStore.newBetsCount;
    }
  },
  watch: {
    newBetsCount(newVal, oldVal) {
      if (newVal > oldVal) {
        this.$refs.redDot.classList.remove('hidden');
        this.$refs.pinging.classList.remove('animate-ping-once');
        setTimeout(() => {
          this.$refs.pinging.classList.add('animate-ping-once');
        }, 0);
      }
      if (newVal === 0) {
        this.$refs.redDot.classList.add('hidden');
      }
    }
  },
  mounted() {
    let tab = 'TabBets';
    let hash = window.location.hash.substring(1);
    const availableTabs = this.betStore.navItems.map(item => item.query_name);
    if (availableTabs.includes(hash)) {
      tab = this.betStore.getNavItemTabName(hash);
      let urlWithoutHash = window.location.href.substring(0, window.location.href.indexOf('#'));
      window.history.replaceState(null, '', urlWithoutHash);
    }
    this.changeTab(tab);
  },
  methods: {
    changeTab(tabName) {
      if (tabName === 'TabBets' && this.betStore.selectedTab === 'TabBets') {
        scrollTo(0,0);
      } else {
        this.betStore.changeTab(tabName);
      }
    },
  },
};
</script>

<style scoped>
.tab-selected {
  @apply bg-zt-light hover:!bg-zt-light
    before:bg-zt-red before:w-1 before:h-3/4 before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2;
}
</style>